import { useContext, useEffect, useState } from 'react';

//context
import {LanguageContext} from '@/context/LanguageContext';
import { container, TYPES } from '@/inversifyconfig/container.config';

//interfaces
import { IHttpRequest } from '@/interfaces/IHttp';
import {ILanguagesTab, Language, NotificationStatus} from '@/interfaces/languages';



export const UseLanguagesTab = ({ setDctEnabled, setQuickTranslateDisabled, toggleNotification}:ILanguagesTab) => {
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);
    const languageContext = useContext(LanguageContext);
    
    const [formTouched, setFormTouched] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [languages, setLanguages] = useState<Language[]>([]);
    const [settingsLanguage, setSettingsLanguage] = useState<Language>();
    const [settingsModal, setSettingsModal] = useState<boolean>(false);

    useEffect(() => {
        getLanguages();        
    }, []);

    useEffect(() => {
        // Move into context
        if (languages){
            const available = languages.filter(x => x.enabled);
    
            languageContext.setStore({
                ...languageContext.store, 
                languageAvailable:available
            });
        }

        // Enable/Disabled DCT
        languages.filter(x => x.enabled).length > 0 ? setQuickTranslateDisabled(false) : setQuickTranslateDisabled(true);
    }, [languages])

    function getLanguages(){
        httpCall.get('admin/languages').then(({data:{dctEnabled, languages}}:{ data: {dctEnabled:boolean,languages:Language[]} }) => {
            if (languages.length){
                // Track if settings have been saved
                for (const lang of languages){
                    lang.settingsSaved = lang.enabled;
                }
                setLanguages(languages); 
            } 
            setDctEnabled(dctEnabled);
        })
        .catch((e) => {
          console.error(e, ":Failed")      
        });
    }

    function handleChecked(lang:Language){
        setFormTouched(true);
    
        const langs = [...languages]
        const selected = langs.findIndex(x => x.languageId === lang.languageId);
        if (selected !== -1){
            langs[selected].enabled = !langs[selected].enabled;
            setLanguages(langs);
        }
    }

    function settingsSelected(language:Language){
        setSettingsLanguage(language)
        setSettingsModal(true)
    }

    function submit(){
        if (formTouched){
            setLoading(true)

            httpCall.put('admin/languages', languages)
            .then(() => {
                getLanguages();
                toggleNotification( {show:true, notificationStatus:NotificationStatus.success, msg:"Saved", notificationType:null})
            })
            .catch(() => {
                toggleNotification( {show:true, notificationStatus:NotificationStatus.error, msg:"Could not save changes at this time", notificationType:null})
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    function downloadReport(){
        window.location.assign('/api/admin/languages/report')
    }

    return {
        languages,
        handleChecked,
        formTouched,
        submit,
        loading,
        downloadReport,
        settingsLanguage,
        settingsModal,
        settingsSelected,
        setSettingsModal
    }
};